/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { AutocompleteItemDto, ID, WithDirtyType, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';

export type ReportRohcAreaDto = WithVersion<WithDirtyType<{
  id: ID;
  name: string;
  description: string;
  details: ReportRohcOfficeDto[];
}>>;

export type ReportRohcOfficeDto = WithDirtyType<{
  officeId: ID;
  name: string;
  masterZoneCode: string;
  housePlan?: AutocompleteItemDto;
}>;

export type ReportRohcMasterCostCenterDto = WithVersion<WithDirtyType<{
  id: ID;
  code: number;
  name: string;
  details: ReportRohcOfficeCostCenterDto[];
}>>;

export type ReportRohcOfficeCostCenterDto = WithDirtyType<{
  costCenterId: ID;
  code: number;
  name: string;
  officeId: ID;
  officeName: string;
  housePlanId?: ID;
  housePlanCode?: string;
  isActive: boolean;
}>;

export type ReportRohcDetailsDto = {
  areas: ReportRohcAreaDto[];
  masterCostCenters: ReportRohcMasterCostCenterDto[];
};

export class ReportRohcOfficeFilterDto {
  searchString?: string;
}

export class ReportRohcCostCenterFilterDto {
  searchString?: string;
  housePlanIds: ID[];
}

export const FinancialIndexes = createEnum('FINANCIAL_INDEXES', {
  Sales: 1,
  Overheads: 2,
  ProfitOnFinalizedJobs: 3,
  Breakeven: 4,
  GpSales: 5,
  NpSales: 6,
  OverheadsSales: 7,
  WagesSales: 8,
  AdvertisingSales: 9,
  AdvertisingSpend: 10,
  Debtors: 14,
  FinalizedJobGp: 17,
  FinalizedJobNp: 18,
  ContractsProfitForecastNp: 19,
  SalesYtd: 20,
  GpSales2: 21,
  OverheadsSales2: 22,
  AdvertisingSales2: 23,
  WagesSales2: 24,
  NpSales2: 25,
  AverageFinalizedGrossProfit: 26,
});

export type FinancialIndexes = EnumSet<typeof FinancialIndexes>;

export type ReportFyaThresholdDto = WithVersion<WithDirtyType<{
  id: ID;
  type: FinancialIndexes;
  goodFrom1: number;
  goodFrom1Include: boolean;
  goodTo1: number;
  goodTo1Include: boolean;
  okFrom1: number;
  okFrom1Include: boolean;
  okTo1: number;
  okTo1Include: boolean;
  badFrom1: number;
  badFrom1Include: boolean;
  badTo1: number;
  badTo1Include: boolean;
  goodFrom2: number;
  goodFrom2Include: boolean;
  goodTo2: number;
  goodTo2Include: boolean;
  okFrom2: number;
  okFrom2Include: boolean;
  okTo2: number;
  okTo2Include: boolean;
  badFrom2: number;
  badFrom2Include: boolean;
  badTo2: number;
  badTo2Include: boolean;
}>>;

export type ReportFyaDetailsDto = {
  thresholds: ReportFyaThresholdDto[];
  keyGoals: ReportFyaKeyGoalDto[];
};

export type ReportFyaKeyGoalDto = WithDirtyType<{
  officeId: ID;
  keyGoals: string;
  comments: string;
}>;
